import ResetPwdForm from "@/components/form/ResetPwdForm";
import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const ResetPwd = () => {
  const navigate = useNavigate();
  const { token } = useParams();

  useEffect(() => {
    if (!token) {
      navigate(`/forget-password`);
    }
  }, []);
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "14px",
          display: "flex",
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: "25%",
            backgroundColor: theme => theme.palette.secondary.main,
          }}
        />
        <Box
          sx={{
            height: "100%",
            width: "85%",
            backgroundColor: theme => theme.palette.primary.main,
          }}
        />
        <Box
          sx={{
            height: "100%",
            width: "10%",
            backgroundColor: theme => theme.palette.info.main,
          }}
        />
      </Box>
      <Box
        sx={{
          height: "90vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ResetPwdForm />
      </Box>
    </>
  );
};

export default ResetPwd;
